import { render } from "./CancelAppointmentPopup.vue?vue&type=template&id=20e5cbb6&scoped=true"
import script from "./CancelAppointmentPopup.vue?vue&type=script&lang=js"
export * from "./CancelAppointmentPopup.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-20e5cbb6"

export default script